export default class API {

  constructor() {
    this.swagger = document.querySelector('#swagger-ui');
    if (this.swagger) {
      this.initialize();
    }
  }

  initialize() {
    const me = this;

    const ui = SwaggerUIBundle({
      url: this.swagger.dataset.url || '/swagger.json',
      dom_id: '#swagger-ui',
      deepLinking: true,
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIStandalonePreset
      ],
      plugins: [
        SwaggerUIBundle.plugins.DownloadUrl
      ],
      layout: 'StandaloneLayout',
      onComplete() {
      if (me.swagger.dataset.mode === 'organization') {
         // Change all "tags" from PascalCase to words. Eg.
         // CatalogPlan -> Catalog Plan
         // CloudAccount -> Cloud Account
          document.querySelectorAll('.opblock-tag').forEach((el) => {
            const span = el.querySelector('a > span');
            if (span) {
              span.innerHTML = span.innerHTML.replace(/([A-Z])/g, " $1");
            }
          });
          // Hide heading.
          document.querySelector('.information-container').style.display = 'none';
        }
      },
    });

    window.ui = ui;
  }
}
